import { render, staticRenderFns } from "./PictureBookThumb.vue?vue&type=template&id=06ee154d&"
import script from "./PictureBookThumb.vue?vue&type=script&lang=js&"
export * from "./PictureBookThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports